export default __webpack_public_path__ + "static/media/vouchers.0233dd08.png";